import { Box, styled } from "@mui/material";

export const LoadingScreen = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  paddingTop: "200px",
})) as typeof Box;
